import React from "react";
import { Table, Text } from "@mantine/core";
import dayjs from "dayjs";
import type { DeviceEvent } from "../../services/bridgeService";

interface Props {
  events: DeviceEvent[];
  loading?: boolean;
}

const DeviceEventTable: React.FC<Props> = ({ events, loading }) => {
  if (!events.length && !loading) {
    return (
      <Text c="dimmed" ta="center" py="xl">
        No events found
      </Text>
    );
  }

  return (
    <Table striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Timestamp</Table.Th>
          <Table.Th>Event Type</Table.Th>
          <Table.Th>Device</Table.Th>
          <Table.Th>Data</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {events.map((event) => (
          <Table.Tr key={event.id}>
            <Table.Td>
              {dayjs(event.occurredAt).format("YYYY-MM-DD HH:mm:ss")}
            </Table.Td>
            <Table.Td>{event.eventType}</Table.Td>
            <Table.Td>{event.deviceId}</Table.Td>
            <Table.Td>
              <Text size="xs" lineClamp={1}>
                {JSON.stringify(event.data)}
              </Text>
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};

export default DeviceEventTable;
